import React, { MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';
import { Button } from '../buttons/button/Button';
import { Spinner } from '../loaders/spinner/Spinner';
import styles from './OrderButton.module.scss';

export const OrderButton = ({
    loading, onClick,
    className, contentClassName, disabled,
    children, title,
    label
}: OrderButtonProps) => {

    const buttonClasses = classNames('idt-order-button', className, {
        'idt-order-button--disabled': disabled,
        [styles.loading]: loading
    });

    const contentClasses = classNames('idt-order-button__content', contentClassName);

    return (
        <Button className={buttonClasses} disabled={disabled} onClick={onClick} title={title}>

            {label}

            <span className={contentClasses}>
                {loading && (
                    <Spinner
                        className={styles.spinner} color='white'
                        overlaySize='auto' spinnerSize='small' />
                )}

                {children}
            </span>
        </Button>
    );
};

export type OrderButtonProps = PropsWithChildren<{
    disabled?: boolean;
    onClick: MouseEventHandler;
    loading: boolean;
    className?: string;
    contentClassName?: string;
    title?: string;
    label?: ReactNode;
}>;